import ActionTypes from './types'
import * as queries from '../lib/queries'
import {OCCUPANCY_STATUS_PAST, OCCUPANCY_STATUS_CURRENT} from '../constants/ModelConstants'

export const setBuildingsAll = (dispatch, buildings) => {
  dispatch({
    type: ActionTypes.BUILDINGS_UPDATE_ALL,
    payload: buildings,
  })
}

/**
 * Add a dummy user to the residents list
 * @param {Dispatch} dispatch
 * @param {string} buildingId
 * @param {string} phone
 * @param {string} name
 * @param {boolean} isActive
 */
export const updateDummyUser = async (dispatch, buildingId, phone, name, isActive) => {
  const updatedResident = await queries.updateDummyResident({
    buildingId: buildingId,
    phoneNumber: phone,
    displayName: name,
    status: isActive ? OCCUPANCY_STATUS_CURRENT : OCCUPANCY_STATUS_PAST,
  })

  dispatch({
    type: ActionTypes.RESIDENT_UPDATE_SINGLE,
    payload: updatedResident,
  })

  dispatch({
    type: ActionTypes.BUILDINGS_UPDATE_DUMMY_RESIDENT,
    payload: {
      buildingId: buildingId,
      dummyResidentId: updatedResident.id,
    },
  })

  return updatedResident
}

/**
 * @param {Dispatch} dispatch
 * @param {string} buildingId
 * @param {*} input
 * @return {Promise<*>}
 */
export const setBuildingData = async (dispatch, buildingId, input) => {
  let updatedBuilding = await queries.updateBuilding({...input, id: buildingId})

  // assume it worked, we'll revert below if it doesn't
  dispatch({
    type: ActionTypes.BUILDINGS_UPDATE,
    payload: updatedBuilding,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {*} resident
 * @return {Promise<void>}
 */
export const setUpdateResident = async (dispatch, resident) => {
  let updatedResident = await queries.updateResidentProfile(resident)

  dispatch({
    type: ActionTypes.RESIDENT_UPDATE_SINGLE,
    payload: updatedResident,
  })
}

/**
 * @param {Dispatch} dispatch
 * @param {string} nextBuildingId
 * @param {string?} previousBuildingId
 * @returns {Promise<void>}
 */
export const setBuildingViewing = async (dispatch, nextBuildingId, previousBuildingId) => {
  // only dispatch a building set viewing if the building as changed (otherwise, just reload data)
  // because some reducers will reset to initial state on building change, so if we're not actually changing buildings
  // don't want to trigger it
  if (nextBuildingId !== previousBuildingId) {
    dispatch({
      type: ActionTypes.BUILDINGS_SET_VIEWING,
      payload: nextBuildingId,
    })
  }

  // Load residents, units, and occupancies for the active building only
  // Sister building data is loaded separately via sisterBuildingDataActions for amenities/events
   // TODO: I'd like to break this into 3 flat queries for units, residents, and occupancies, but getting residents and occupancies without going via units is impossible
  let [units, residents, occupancies] = await queries.loadUnitsAndResidentsAndOnboardingOccupanciesForBuilding(nextBuildingId)

  dispatch({
    type: ActionTypes.RESIDENTS_UPDATE_ALL,
    payload: residents,
  })

  dispatch({
    type: ActionTypes.UNITS_UPDATE_ALL,
    payload: units,
  })

  dispatch({
    type: ActionTypes.OCCUPANCIES_UPDATE_ALL,
    payload: occupancies,
  })

  const chatRooms = await queries.loadChatRoomsByBuilding(nextBuildingId)
  let chatParticipants = []
  for (const chatRoom of chatRooms) {
    if (chatRoom.chatParticipants && Array.isArray(chatRoom.chatParticipants)) {
      chatParticipants = chatParticipants.concat(chatRoom.chatParticipants)
    }
  }

  dispatch({
    type: ActionTypes.CHAT_PARTICIPANTS_UPDATE_ALL,
    payload: chatParticipants,
  })
}
